var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
import { DUMMY_BASE_URL, assertParamExists, setBearerAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, operationServerMap } from './base';
export const AuthType = {
    IdPassword: 'ID_PASSWORD',
    Sso: 'SSO'
};
export const ImportUserLogResponseStatusEnum = {
    Success: 'SUCCESS',
    Importing: 'IMPORTING',
    ImportError: 'IMPORT_ERROR',
    IllegalError: 'ILLEGAL_ERROR'
};
export const OrganizationListKind = {
    None: 'NONE',
    Clazz: 'CLAZZ',
    Group: 'GROUP'
};
export const OrganizationSortBy = {
    None: 'NONE',
    Order: 'ORDER',
    GradeOrder: 'GRADE_ORDER'
};
export const OrganizationType = {
    Unspecified: 'UNSPECIFIED',
    Clazz: 'CLAZZ',
    Group: 'GROUP'
};
export const ResponseUserWorkStatusEnum = {
    Updating: 'UPDATING',
    Deleting: 'DELETING',
    Success: 'SUCCESS',
    Failed: 'FAILED'
};
export const Role = {
    AdministratorTeacher: 'ADMINISTRATOR_TEACHER',
    Teacher: 'TEACHER',
    Student: 'STUDENT',
    AdministratorCustomer: 'ADMINISTRATOR_CUSTOMER',
    Customer: 'CUSTOMER'
};
export const SortOrder = {
    Asc: 'ASC',
    Desc: 'DESC'
};
export const UserAttributesResponseSchoolTypeEnum = {
    ElementarySchool: 'ELEMENTARY_SCHOOL',
    MiddleSchool: 'MIDDLE_SCHOOL',
    CompulsoryEducationSchool: 'COMPULSORY_EDUCATION_SCHOOL'
};
export const UserListKind = {
    None: 'NONE',
    Organization: 'ORGANIZATION',
    Teacher: 'TEACHER',
    NotSet: 'NOT_SET',
    School: 'SCHOOL'
};
export const UserSchoolResponseTypeEnum = {
    ElementarySchool: 'ELEMENTARY_SCHOOL',
    MiddleSchool: 'MIDDLE_SCHOOL',
    CompulsoryEducationSchool: 'COMPULSORY_EDUCATION_SCHOOL'
};
export const UserSortBy = {
    None: 'NONE',
    Order: 'ORDER',
    LoginId: 'LOGIN_ID',
    Name: 'NAME',
    Ruby: 'RUBY',
    Role: 'ROLE',
    EnrolledYear: 'ENROLLED_YEAR',
    MailAddress: 'MAIL_ADDRESS',
    SchoolId: 'SCHOOL_ID',
    JoinedSchoolDatetime: 'JOINED_SCHOOL_DATETIME',
    Status: 'STATUS'
};
export const UserStatus = {
    Active: 'ACTIVE',
    Graduate: 'GRADUATE',
    Delete: 'DELETE'
};
export const ExportUserOrganizationMembershipControllerApiAxiosParamCreator = function (configuration) {
    return {
        getUserClazzMembershipCsvDownloadLink: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/organizations/members/export`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const ExportUserOrganizationMembershipControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = ExportUserOrganizationMembershipControllerApiAxiosParamCreator(configuration);
    return {
        getUserClazzMembershipCsvDownloadLink(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUserClazzMembershipCsvDownloadLink(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ExportUserOrganizationMembershipControllerApi.getUserClazzMembershipCsvDownloadLink']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
export const ExportUserOrganizationMembershipControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ExportUserOrganizationMembershipControllerApiFp(configuration);
    return {
        getUserClazzMembershipCsvDownloadLink(options) {
            return localVarFp.getUserClazzMembershipCsvDownloadLink(options).then((request) => request(axios, basePath));
        },
    };
};
export class ExportUserOrganizationMembershipControllerApi extends BaseAPI {
    getUserClazzMembershipCsvDownloadLink(options) {
        return ExportUserOrganizationMembershipControllerApiFp(this.configuration).getUserClazzMembershipCsvDownloadLink(options).then((request) => request(this.axios, this.basePath));
    }
}
export const FiscalYearControllerApiAxiosParamCreator = function (configuration) {
    return {
        getFiscalYear: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/fiscal-years`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const FiscalYearControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = FiscalYearControllerApiAxiosParamCreator(configuration);
    return {
        getFiscalYear(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getFiscalYear(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['FiscalYearControllerApi.getFiscalYear']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
export const FiscalYearControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = FiscalYearControllerApiFp(configuration);
    return {
        getFiscalYear(options) {
            return localVarFp.getFiscalYear(options).then((request) => request(axios, basePath));
        },
    };
};
export class FiscalYearControllerApi extends BaseAPI {
    getFiscalYear(options) {
        return FiscalYearControllerApiFp(this.configuration).getFiscalYear(options).then((request) => request(this.axios, this.basePath));
    }
}
export const ImportUserOrganizationMembershipControllerApiAxiosParamCreator = function (configuration) {
    return {
        importUserClazzMemberships: (file_1, ...args_1) => __awaiter(this, [file_1, ...args_1], void 0, function* (file, options = {}) {
            assertParamExists('importUserClazzMemberships', 'file', file);
            const localVarPath = `/organizations/members/import`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (file !== undefined) {
                localVarFormParams.append('file', file);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const ImportUserOrganizationMembershipControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = ImportUserOrganizationMembershipControllerApiAxiosParamCreator(configuration);
    return {
        importUserClazzMemberships(file, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.importUserClazzMemberships(file, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ImportUserOrganizationMembershipControllerApi.importUserClazzMemberships']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
export const ImportUserOrganizationMembershipControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ImportUserOrganizationMembershipControllerApiFp(configuration);
    return {
        importUserClazzMemberships(file, options) {
            return localVarFp.importUserClazzMemberships(file, options).then((request) => request(axios, basePath));
        },
    };
};
export class ImportUserOrganizationMembershipControllerApi extends BaseAPI {
    importUserClazzMemberships(file, options) {
        return ImportUserOrganizationMembershipControllerApiFp(this.configuration).importUserClazzMemberships(file, options).then((request) => request(this.axios, this.basePath));
    }
}
export const InternalUserControllerApiAxiosParamCreator = function (configuration) {
    return {
        deleteUsersByIds: (deletionUsersRequest_1, ...args_1) => __awaiter(this, [deletionUsersRequest_1, ...args_1], void 0, function* (deletionUsersRequest, options = {}) {
            assertParamExists('deleteUsersByIds', 'deletionUsersRequest', deletionUsersRequest);
            const localVarPath = `/internal/users/delete`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(deletionUsersRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        getUserAttributes: (username_1, ...args_1) => __awaiter(this, [username_1, ...args_1], void 0, function* (username, options = {}) {
            assertParamExists('getUserAttributes', 'username', username);
            const localVarPath = `/internal/users/{username}/attributes`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        linkUser: (userLinkRequest_1, ...args_1) => __awaiter(this, [userLinkRequest_1, ...args_1], void 0, function* (userLinkRequest, options = {}) {
            assertParamExists('linkUser', 'userLinkRequest', userLinkRequest);
            const localVarPath = `/internal/users/link`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(userLinkRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const InternalUserControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = InternalUserControllerApiAxiosParamCreator(configuration);
    return {
        deleteUsersByIds(deletionUsersRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteUsersByIds(deletionUsersRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['InternalUserControllerApi.deleteUsersByIds']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        getUserAttributes(username, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUserAttributes(username, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['InternalUserControllerApi.getUserAttributes']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        linkUser(userLinkRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.linkUser(userLinkRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['InternalUserControllerApi.linkUser']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
export const InternalUserControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = InternalUserControllerApiFp(configuration);
    return {
        deleteUsersByIds(deletionUsersRequest, options) {
            return localVarFp.deleteUsersByIds(deletionUsersRequest, options).then((request) => request(axios, basePath));
        },
        getUserAttributes(username, options) {
            return localVarFp.getUserAttributes(username, options).then((request) => request(axios, basePath));
        },
        linkUser(userLinkRequest, options) {
            return localVarFp.linkUser(userLinkRequest, options).then((request) => request(axios, basePath));
        },
    };
};
export class InternalUserControllerApi extends BaseAPI {
    deleteUsersByIds(deletionUsersRequest, options) {
        return InternalUserControllerApiFp(this.configuration).deleteUsersByIds(deletionUsersRequest, options).then((request) => request(this.axios, this.basePath));
    }
    getUserAttributes(username, options) {
        return InternalUserControllerApiFp(this.configuration).getUserAttributes(username, options).then((request) => request(this.axios, this.basePath));
    }
    linkUser(userLinkRequest, options) {
        return InternalUserControllerApiFp(this.configuration).linkUser(userLinkRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
export const OrganizationControllerApiAxiosParamCreator = function (configuration) {
    return {
        addOrganization: (postOrganizationRequest_1, ...args_1) => __awaiter(this, [postOrganizationRequest_1, ...args_1], void 0, function* (postOrganizationRequest, options = {}) {
            assertParamExists('addOrganization', 'postOrganizationRequest', postOrganizationRequest);
            const localVarPath = `/organizations`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(postOrganizationRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        deleteOrganizationById: (organizationId_1, ...args_1) => __awaiter(this, [organizationId_1, ...args_1], void 0, function* (organizationId, options = {}) {
            assertParamExists('deleteOrganizationById', 'organizationId', organizationId);
            const localVarPath = `/organizations/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        getOrganizationById: (organizationId_1, userCountRequired_1, ...args_1) => __awaiter(this, [organizationId_1, userCountRequired_1, ...args_1], void 0, function* (organizationId, userCountRequired, options = {}) {
            assertParamExists('getOrganizationById', 'organizationId', organizationId);
            const localVarPath = `/organizations/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (userCountRequired !== undefined) {
                localVarQueryParameter['userCountRequired'] = userCountRequired;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        getOrganizations: (listKinds_1, aggregationOnly_1, sortBy_1, sortOrder_1, userCountRequired_1, ...args_1) => __awaiter(this, [listKinds_1, aggregationOnly_1, sortBy_1, sortOrder_1, userCountRequired_1, ...args_1], void 0, function* (listKinds, aggregationOnly, sortBy, sortOrder, userCountRequired, options = {}) {
            const localVarPath = `/organizations`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (listKinds) {
                localVarQueryParameter['listKinds'] = listKinds.join(COLLECTION_FORMATS.csv);
            }
            if (aggregationOnly !== undefined) {
                localVarQueryParameter['aggregationOnly'] = aggregationOnly;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }
            if (userCountRequired !== undefined) {
                localVarQueryParameter['userCountRequired'] = userCountRequired;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        updateOrganization: (putOrganizationsRequest_1, ...args_1) => __awaiter(this, [putOrganizationsRequest_1, ...args_1], void 0, function* (putOrganizationsRequest, options = {}) {
            assertParamExists('updateOrganization', 'putOrganizationsRequest', putOrganizationsRequest);
            const localVarPath = `/organizations`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(putOrganizationsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        updateOrganization1: (organizationId_1, putOrganizationRequest_1, ...args_1) => __awaiter(this, [organizationId_1, putOrganizationRequest_1, ...args_1], void 0, function* (organizationId, putOrganizationRequest, options = {}) {
            assertParamExists('updateOrganization1', 'organizationId', organizationId);
            assertParamExists('updateOrganization1', 'putOrganizationRequest', putOrganizationRequest);
            const localVarPath = `/organizations/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(putOrganizationRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const OrganizationControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = OrganizationControllerApiAxiosParamCreator(configuration);
    return {
        addOrganization(postOrganizationRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addOrganization(postOrganizationRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['OrganizationControllerApi.addOrganization']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        deleteOrganizationById(organizationId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrganizationById(organizationId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['OrganizationControllerApi.deleteOrganizationById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        getOrganizationById(organizationId, userCountRequired, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getOrganizationById(organizationId, userCountRequired, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['OrganizationControllerApi.getOrganizationById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        getOrganizations(listKinds, aggregationOnly, sortBy, sortOrder, userCountRequired, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getOrganizations(listKinds, aggregationOnly, sortBy, sortOrder, userCountRequired, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['OrganizationControllerApi.getOrganizations']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        updateOrganization(putOrganizationsRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateOrganization(putOrganizationsRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['OrganizationControllerApi.updateOrganization']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        updateOrganization1(organizationId, putOrganizationRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateOrganization1(organizationId, putOrganizationRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['OrganizationControllerApi.updateOrganization1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
export const OrganizationControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = OrganizationControllerApiFp(configuration);
    return {
        addOrganization(postOrganizationRequest, options) {
            return localVarFp.addOrganization(postOrganizationRequest, options).then((request) => request(axios, basePath));
        },
        deleteOrganizationById(organizationId, options) {
            return localVarFp.deleteOrganizationById(organizationId, options).then((request) => request(axios, basePath));
        },
        getOrganizationById(organizationId, userCountRequired, options) {
            return localVarFp.getOrganizationById(organizationId, userCountRequired, options).then((request) => request(axios, basePath));
        },
        getOrganizations(listKinds, aggregationOnly, sortBy, sortOrder, userCountRequired, options) {
            return localVarFp.getOrganizations(listKinds, aggregationOnly, sortBy, sortOrder, userCountRequired, options).then((request) => request(axios, basePath));
        },
        updateOrganization(putOrganizationsRequest, options) {
            return localVarFp.updateOrganization(putOrganizationsRequest, options).then((request) => request(axios, basePath));
        },
        updateOrganization1(organizationId, putOrganizationRequest, options) {
            return localVarFp.updateOrganization1(organizationId, putOrganizationRequest, options).then((request) => request(axios, basePath));
        },
    };
};
export class OrganizationControllerApi extends BaseAPI {
    addOrganization(postOrganizationRequest, options) {
        return OrganizationControllerApiFp(this.configuration).addOrganization(postOrganizationRequest, options).then((request) => request(this.axios, this.basePath));
    }
    deleteOrganizationById(organizationId, options) {
        return OrganizationControllerApiFp(this.configuration).deleteOrganizationById(organizationId, options).then((request) => request(this.axios, this.basePath));
    }
    getOrganizationById(organizationId, userCountRequired, options) {
        return OrganizationControllerApiFp(this.configuration).getOrganizationById(organizationId, userCountRequired, options).then((request) => request(this.axios, this.basePath));
    }
    getOrganizations(listKinds, aggregationOnly, sortBy, sortOrder, userCountRequired, options) {
        return OrganizationControllerApiFp(this.configuration).getOrganizations(listKinds, aggregationOnly, sortBy, sortOrder, userCountRequired, options).then((request) => request(this.axios, this.basePath));
    }
    updateOrganization(putOrganizationsRequest, options) {
        return OrganizationControllerApiFp(this.configuration).updateOrganization(putOrganizationsRequest, options).then((request) => request(this.axios, this.basePath));
    }
    updateOrganization1(organizationId, putOrganizationRequest, options) {
        return OrganizationControllerApiFp(this.configuration).updateOrganization1(organizationId, putOrganizationRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
export const ProfileControllerApiAxiosParamCreator = function (configuration) {
    return {
        deleteProfileIcon: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/users/profile/icon`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        uploadProfileIcon: (file_1, ...args_1) => __awaiter(this, [file_1, ...args_1], void 0, function* (file, options = {}) {
            assertParamExists('uploadProfileIcon', 'file', file);
            const localVarPath = `/users/profile/icon`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (file !== undefined) {
                localVarFormParams.append('file', file);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const ProfileControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = ProfileControllerApiAxiosParamCreator(configuration);
    return {
        deleteProfileIcon(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteProfileIcon(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ProfileControllerApi.deleteProfileIcon']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        uploadProfileIcon(file, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.uploadProfileIcon(file, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ProfileControllerApi.uploadProfileIcon']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
export const ProfileControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ProfileControllerApiFp(configuration);
    return {
        deleteProfileIcon(options) {
            return localVarFp.deleteProfileIcon(options).then((request) => request(axios, basePath));
        },
        uploadProfileIcon(file, options) {
            return localVarFp.uploadProfileIcon(file, options).then((request) => request(axios, basePath));
        },
    };
};
export class ProfileControllerApi extends BaseAPI {
    deleteProfileIcon(options) {
        return ProfileControllerApiFp(this.configuration).deleteProfileIcon(options).then((request) => request(this.axios, this.basePath));
    }
    uploadProfileIcon(file, options) {
        return ProfileControllerApiFp(this.configuration).uploadProfileIcon(file, options).then((request) => request(this.axios, this.basePath));
    }
}
export const SchoolOptionControllerApiAxiosParamCreator = function (configuration) {
    return {
        getSchoolOption: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/school-options`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        updateSchoolOption: (schoolOptionRequest_1, ...args_1) => __awaiter(this, [schoolOptionRequest_1, ...args_1], void 0, function* (schoolOptionRequest, options = {}) {
            assertParamExists('updateSchoolOption', 'schoolOptionRequest', schoolOptionRequest);
            const localVarPath = `/school-options`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(schoolOptionRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const SchoolOptionControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = SchoolOptionControllerApiAxiosParamCreator(configuration);
    return {
        getSchoolOption(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSchoolOption(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['SchoolOptionControllerApi.getSchoolOption']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        updateSchoolOption(schoolOptionRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateSchoolOption(schoolOptionRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['SchoolOptionControllerApi.updateSchoolOption']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
export const SchoolOptionControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SchoolOptionControllerApiFp(configuration);
    return {
        getSchoolOption(options) {
            return localVarFp.getSchoolOption(options).then((request) => request(axios, basePath));
        },
        updateSchoolOption(schoolOptionRequest, options) {
            return localVarFp.updateSchoolOption(schoolOptionRequest, options).then((request) => request(axios, basePath));
        },
    };
};
export class SchoolOptionControllerApi extends BaseAPI {
    getSchoolOption(options) {
        return SchoolOptionControllerApiFp(this.configuration).getSchoolOption(options).then((request) => request(this.axios, this.basePath));
    }
    updateSchoolOption(schoolOptionRequest, options) {
        return SchoolOptionControllerApiFp(this.configuration).updateSchoolOption(schoolOptionRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
export const UserControllerApiAxiosParamCreator = function (configuration) {
    return {
        addUser: (postUserRequest_1, ...args_1) => __awaiter(this, [postUserRequest_1, ...args_1], void 0, function* (postUserRequest, options = {}) {
            assertParamExists('addUser', 'postUserRequest', postUserRequest);
            const localVarPath = `/users`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(postUserRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        deleteUserById: (userId_1, ...args_1) => __awaiter(this, [userId_1, ...args_1], void 0, function* (userId, options = {}) {
            assertParamExists('deleteUserById', 'userId', userId);
            const localVarPath = `/users/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        downloadImportErrorLog: (logId_1, ...args_1) => __awaiter(this, [logId_1, ...args_1], void 0, function* (logId, options = {}) {
            assertParamExists('downloadImportErrorLog', 'logId', logId);
            const localVarPath = `/users/import/logs/error/{logId}`
                .replace(`{${"logId"}}`, encodeURIComponent(String(logId)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        downloadUsersAtCSV: (role_1, authType_1, ...args_1) => __awaiter(this, [role_1, authType_1, ...args_1], void 0, function* (role, authType, options = {}) {
            const localVarPath = `/users/export`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }
            if (authType !== undefined) {
                localVarQueryParameter['authType'] = authType;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        getAvailableUsersByIds: (getUsersRequest_1, ...args_1) => __awaiter(this, [getUsersRequest_1, ...args_1], void 0, function* (getUsersRequest, options = {}) {
            assertParamExists('getAvailableUsersByIds', 'getUsersRequest', getUsersRequest);
            const localVarPath = `/users/read/check`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getUsersRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        getCurrentUser: (organizationInfo_1, schoolInfo_1, previousSchoolInfo_1, customerInfo_1, profileIconInfo_1, ...args_1) => __awaiter(this, [organizationInfo_1, schoolInfo_1, previousSchoolInfo_1, customerInfo_1, profileIconInfo_1, ...args_1], void 0, function* (organizationInfo, schoolInfo, previousSchoolInfo, customerInfo, profileIconInfo, options = {}) {
            const localVarPath = `/users/current`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (organizationInfo !== undefined) {
                localVarQueryParameter['organizationInfo'] = organizationInfo;
            }
            if (schoolInfo !== undefined) {
                localVarQueryParameter['schoolInfo'] = schoolInfo;
            }
            if (previousSchoolInfo !== undefined) {
                localVarQueryParameter['previousSchoolInfo'] = previousSchoolInfo;
            }
            if (customerInfo !== undefined) {
                localVarQueryParameter['customerInfo'] = customerInfo;
            }
            if (profileIconInfo !== undefined) {
                localVarQueryParameter['profileIconInfo'] = profileIconInfo;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        getImportLogs: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/users/import/logs`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        getUsers: (organizationInfo_1, ordinal_1, listKind_1, role_1, organizationId_1, schoolId_1, query_1, enrolledYearStart_1, enrolledYearEnd_1, authType_1, status_1, sortBy_1, sortOrder_1, limit_1, offset_1, ...args_1) => __awaiter(this, [organizationInfo_1, ordinal_1, listKind_1, role_1, organizationId_1, schoolId_1, query_1, enrolledYearStart_1, enrolledYearEnd_1, authType_1, status_1, sortBy_1, sortOrder_1, limit_1, offset_1, ...args_1], void 0, function* (organizationInfo, ordinal, listKind, role, organizationId, schoolId, query, enrolledYearStart, enrolledYearEnd, authType, status, sortBy, sortOrder, limit, offset, options = {}) {
            const localVarPath = `/users`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (organizationInfo !== undefined) {
                localVarQueryParameter['organizationInfo'] = organizationInfo;
            }
            if (ordinal !== undefined) {
                localVarQueryParameter['ordinal'] = ordinal;
            }
            if (listKind !== undefined) {
                localVarQueryParameter['listKind'] = listKind;
            }
            if (role) {
                localVarQueryParameter['role'] = role.join(COLLECTION_FORMATS.csv);
            }
            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }
            if (schoolId !== undefined) {
                localVarQueryParameter['schoolId'] = schoolId;
            }
            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }
            if (enrolledYearStart !== undefined) {
                localVarQueryParameter['enrolledYearStart'] = enrolledYearStart;
            }
            if (enrolledYearEnd !== undefined) {
                localVarQueryParameter['enrolledYearEnd'] = enrolledYearEnd;
            }
            if (authType !== undefined) {
                localVarQueryParameter['authType'] = authType;
            }
            if (status) {
                localVarQueryParameter['status'] = status.join(COLLECTION_FORMATS.csv);
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        getUsersByIds: (getUsersRequest_1, organizationInfo_1, ordinal_1, schoolInfo_1, previousSchoolInfo_1, skipNotFoundUser_1, ...args_1) => __awaiter(this, [getUsersRequest_1, organizationInfo_1, ordinal_1, schoolInfo_1, previousSchoolInfo_1, skipNotFoundUser_1, ...args_1], void 0, function* (getUsersRequest, organizationInfo, ordinal, schoolInfo, previousSchoolInfo, skipNotFoundUser, options = {}) {
            assertParamExists('getUsersByIds', 'getUsersRequest', getUsersRequest);
            const localVarPath = `/users/read`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (organizationInfo !== undefined) {
                localVarQueryParameter['organizationInfo'] = organizationInfo;
            }
            if (ordinal !== undefined) {
                localVarQueryParameter['ordinal'] = ordinal;
            }
            if (schoolInfo !== undefined) {
                localVarQueryParameter['schoolInfo'] = schoolInfo;
            }
            if (previousSchoolInfo !== undefined) {
                localVarQueryParameter['previousSchoolInfo'] = previousSchoolInfo;
            }
            if (skipNotFoundUser !== undefined) {
                localVarQueryParameter['skipNotFoundUser'] = skipNotFoundUser;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getUsersRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        importUsers: (role_1, file_1, ssoEnable_1, ...args_1) => __awaiter(this, [role_1, file_1, ssoEnable_1, ...args_1], void 0, function* (role, file, ssoEnable, options = {}) {
            assertParamExists('importUsers', 'role', role);
            assertParamExists('importUsers', 'file', file);
            const localVarPath = `/users/import`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }
            if (ssoEnable !== undefined) {
                localVarQueryParameter['ssoEnable'] = ssoEnable;
            }
            if (file !== undefined) {
                localVarFormParams.append('file', file);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        resetPasswordById: (resetPasswordRequest_1, ...args_1) => __awaiter(this, [resetPasswordRequest_1, ...args_1], void 0, function* (resetPasswordRequest, options = {}) {
            assertParamExists('resetPasswordById', 'resetPasswordRequest', resetPasswordRequest);
            const localVarPath = `/users/password`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(resetPasswordRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        updateUser: (putUserRequest_1, ...args_1) => __awaiter(this, [putUserRequest_1, ...args_1], void 0, function* (putUserRequest, options = {}) {
            assertParamExists('updateUser', 'putUserRequest', putUserRequest);
            const localVarPath = `/users`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(putUserRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const UserControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = UserControllerApiAxiosParamCreator(configuration);
    return {
        addUser(postUserRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addUser(postUserRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['UserControllerApi.addUser']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        deleteUserById(userId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteUserById(userId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['UserControllerApi.deleteUserById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        downloadImportErrorLog(logId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.downloadImportErrorLog(logId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['UserControllerApi.downloadImportErrorLog']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        downloadUsersAtCSV(role, authType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.downloadUsersAtCSV(role, authType, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['UserControllerApi.downloadUsersAtCSV']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        getAvailableUsersByIds(getUsersRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAvailableUsersByIds(getUsersRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['UserControllerApi.getAvailableUsersByIds']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        getCurrentUser(organizationInfo, schoolInfo, previousSchoolInfo, customerInfo, profileIconInfo, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCurrentUser(organizationInfo, schoolInfo, previousSchoolInfo, customerInfo, profileIconInfo, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['UserControllerApi.getCurrentUser']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        getImportLogs(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getImportLogs(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['UserControllerApi.getImportLogs']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        getUsers(organizationInfo, ordinal, listKind, role, organizationId, schoolId, query, enrolledYearStart, enrolledYearEnd, authType, status, sortBy, sortOrder, limit, offset, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUsers(organizationInfo, ordinal, listKind, role, organizationId, schoolId, query, enrolledYearStart, enrolledYearEnd, authType, status, sortBy, sortOrder, limit, offset, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['UserControllerApi.getUsers']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        getUsersByIds(getUsersRequest, organizationInfo, ordinal, schoolInfo, previousSchoolInfo, skipNotFoundUser, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUsersByIds(getUsersRequest, organizationInfo, ordinal, schoolInfo, previousSchoolInfo, skipNotFoundUser, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['UserControllerApi.getUsersByIds']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        importUsers(role, file, ssoEnable, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.importUsers(role, file, ssoEnable, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['UserControllerApi.importUsers']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        resetPasswordById(resetPasswordRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.resetPasswordById(resetPasswordRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['UserControllerApi.resetPasswordById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        updateUser(putUserRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateUser(putUserRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['UserControllerApi.updateUser']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
export const UserControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = UserControllerApiFp(configuration);
    return {
        addUser(postUserRequest, options) {
            return localVarFp.addUser(postUserRequest, options).then((request) => request(axios, basePath));
        },
        deleteUserById(userId, options) {
            return localVarFp.deleteUserById(userId, options).then((request) => request(axios, basePath));
        },
        downloadImportErrorLog(logId, options) {
            return localVarFp.downloadImportErrorLog(logId, options).then((request) => request(axios, basePath));
        },
        downloadUsersAtCSV(role, authType, options) {
            return localVarFp.downloadUsersAtCSV(role, authType, options).then((request) => request(axios, basePath));
        },
        getAvailableUsersByIds(getUsersRequest, options) {
            return localVarFp.getAvailableUsersByIds(getUsersRequest, options).then((request) => request(axios, basePath));
        },
        getCurrentUser(organizationInfo, schoolInfo, previousSchoolInfo, customerInfo, profileIconInfo, options) {
            return localVarFp.getCurrentUser(organizationInfo, schoolInfo, previousSchoolInfo, customerInfo, profileIconInfo, options).then((request) => request(axios, basePath));
        },
        getImportLogs(options) {
            return localVarFp.getImportLogs(options).then((request) => request(axios, basePath));
        },
        getUsers(organizationInfo, ordinal, listKind, role, organizationId, schoolId, query, enrolledYearStart, enrolledYearEnd, authType, status, sortBy, sortOrder, limit, offset, options) {
            return localVarFp.getUsers(organizationInfo, ordinal, listKind, role, organizationId, schoolId, query, enrolledYearStart, enrolledYearEnd, authType, status, sortBy, sortOrder, limit, offset, options).then((request) => request(axios, basePath));
        },
        getUsersByIds(getUsersRequest, organizationInfo, ordinal, schoolInfo, previousSchoolInfo, skipNotFoundUser, options) {
            return localVarFp.getUsersByIds(getUsersRequest, organizationInfo, ordinal, schoolInfo, previousSchoolInfo, skipNotFoundUser, options).then((request) => request(axios, basePath));
        },
        importUsers(role, file, ssoEnable, options) {
            return localVarFp.importUsers(role, file, ssoEnable, options).then((request) => request(axios, basePath));
        },
        resetPasswordById(resetPasswordRequest, options) {
            return localVarFp.resetPasswordById(resetPasswordRequest, options).then((request) => request(axios, basePath));
        },
        updateUser(putUserRequest, options) {
            return localVarFp.updateUser(putUserRequest, options).then((request) => request(axios, basePath));
        },
    };
};
export class UserControllerApi extends BaseAPI {
    addUser(postUserRequest, options) {
        return UserControllerApiFp(this.configuration).addUser(postUserRequest, options).then((request) => request(this.axios, this.basePath));
    }
    deleteUserById(userId, options) {
        return UserControllerApiFp(this.configuration).deleteUserById(userId, options).then((request) => request(this.axios, this.basePath));
    }
    downloadImportErrorLog(logId, options) {
        return UserControllerApiFp(this.configuration).downloadImportErrorLog(logId, options).then((request) => request(this.axios, this.basePath));
    }
    downloadUsersAtCSV(role, authType, options) {
        return UserControllerApiFp(this.configuration).downloadUsersAtCSV(role, authType, options).then((request) => request(this.axios, this.basePath));
    }
    getAvailableUsersByIds(getUsersRequest, options) {
        return UserControllerApiFp(this.configuration).getAvailableUsersByIds(getUsersRequest, options).then((request) => request(this.axios, this.basePath));
    }
    getCurrentUser(organizationInfo, schoolInfo, previousSchoolInfo, customerInfo, profileIconInfo, options) {
        return UserControllerApiFp(this.configuration).getCurrentUser(organizationInfo, schoolInfo, previousSchoolInfo, customerInfo, profileIconInfo, options).then((request) => request(this.axios, this.basePath));
    }
    getImportLogs(options) {
        return UserControllerApiFp(this.configuration).getImportLogs(options).then((request) => request(this.axios, this.basePath));
    }
    getUsers(organizationInfo, ordinal, listKind, role, organizationId, schoolId, query, enrolledYearStart, enrolledYearEnd, authType, status, sortBy, sortOrder, limit, offset, options) {
        return UserControllerApiFp(this.configuration).getUsers(organizationInfo, ordinal, listKind, role, organizationId, schoolId, query, enrolledYearStart, enrolledYearEnd, authType, status, sortBy, sortOrder, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }
    getUsersByIds(getUsersRequest, organizationInfo, ordinal, schoolInfo, previousSchoolInfo, skipNotFoundUser, options) {
        return UserControllerApiFp(this.configuration).getUsersByIds(getUsersRequest, organizationInfo, ordinal, schoolInfo, previousSchoolInfo, skipNotFoundUser, options).then((request) => request(this.axios, this.basePath));
    }
    importUsers(role, file, ssoEnable, options) {
        return UserControllerApiFp(this.configuration).importUsers(role, file, ssoEnable, options).then((request) => request(this.axios, this.basePath));
    }
    resetPasswordById(resetPasswordRequest, options) {
        return UserControllerApiFp(this.configuration).resetPasswordById(resetPasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }
    updateUser(putUserRequest, options) {
        return UserControllerApiFp(this.configuration).updateUser(putUserRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
export const UserOrganizationMembershipControllerApiAxiosParamCreator = function (configuration) {
    return {
        addUserOrganizationMemberships: (organizationId_1, userMembershipsRequest_1, ...args_1) => __awaiter(this, [organizationId_1, userMembershipsRequest_1, ...args_1], void 0, function* (organizationId, userMembershipsRequest, options = {}) {
            assertParamExists('addUserOrganizationMemberships', 'organizationId', organizationId);
            assertParamExists('addUserOrganizationMemberships', 'userMembershipsRequest', userMembershipsRequest);
            const localVarPath = `/organizations/{organizationId}/members`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(userMembershipsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        deleteUserOrganizationMembership: (organizationId_1, userIdsRequest_1, ...args_1) => __awaiter(this, [organizationId_1, userIdsRequest_1, ...args_1], void 0, function* (organizationId, userIdsRequest, options = {}) {
            assertParamExists('deleteUserOrganizationMembership', 'organizationId', organizationId);
            assertParamExists('deleteUserOrganizationMembership', 'userIdsRequest', userIdsRequest);
            const localVarPath = `/organizations/{organizationId}/members`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(userIdsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        updateAllUsersOrganizationMemberships: (organizationType_1, ...args_1) => __awaiter(this, [organizationType_1, ...args_1], void 0, function* (organizationType, options = {}) {
            assertParamExists('updateAllUsersOrganizationMemberships', 'organizationType', organizationType);
            const localVarPath = `/organizations/members`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (organizationType !== undefined) {
                localVarQueryParameter['organizationType'] = organizationType;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        updateCurrentUserOrganizationMemberships: (currentUserMembershipsRequest_1, ...args_1) => __awaiter(this, [currentUserMembershipsRequest_1, ...args_1], void 0, function* (currentUserMembershipsRequest, options = {}) {
            assertParamExists('updateCurrentUserOrganizationMemberships', 'currentUserMembershipsRequest', currentUserMembershipsRequest);
            const localVarPath = `/organizations/members/current`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(currentUserMembershipsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        updateUserOrganizationMemberships: (organizationId_1, userMembershipsRequest_1, ...args_1) => __awaiter(this, [organizationId_1, userMembershipsRequest_1, ...args_1], void 0, function* (organizationId, userMembershipsRequest, options = {}) {
            assertParamExists('updateUserOrganizationMemberships', 'organizationId', organizationId);
            assertParamExists('updateUserOrganizationMemberships', 'userMembershipsRequest', userMembershipsRequest);
            const localVarPath = `/organizations/{organizationId}/members`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(userMembershipsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const UserOrganizationMembershipControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = UserOrganizationMembershipControllerApiAxiosParamCreator(configuration);
    return {
        addUserOrganizationMemberships(organizationId, userMembershipsRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addUserOrganizationMemberships(organizationId, userMembershipsRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['UserOrganizationMembershipControllerApi.addUserOrganizationMemberships']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        deleteUserOrganizationMembership(organizationId, userIdsRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteUserOrganizationMembership(organizationId, userIdsRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['UserOrganizationMembershipControllerApi.deleteUserOrganizationMembership']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        updateAllUsersOrganizationMemberships(organizationType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateAllUsersOrganizationMemberships(organizationType, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['UserOrganizationMembershipControllerApi.updateAllUsersOrganizationMemberships']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        updateCurrentUserOrganizationMemberships(currentUserMembershipsRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateCurrentUserOrganizationMemberships(currentUserMembershipsRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['UserOrganizationMembershipControllerApi.updateCurrentUserOrganizationMemberships']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        updateUserOrganizationMemberships(organizationId, userMembershipsRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateUserOrganizationMemberships(organizationId, userMembershipsRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['UserOrganizationMembershipControllerApi.updateUserOrganizationMemberships']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
export const UserOrganizationMembershipControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = UserOrganizationMembershipControllerApiFp(configuration);
    return {
        addUserOrganizationMemberships(organizationId, userMembershipsRequest, options) {
            return localVarFp.addUserOrganizationMemberships(organizationId, userMembershipsRequest, options).then((request) => request(axios, basePath));
        },
        deleteUserOrganizationMembership(organizationId, userIdsRequest, options) {
            return localVarFp.deleteUserOrganizationMembership(organizationId, userIdsRequest, options).then((request) => request(axios, basePath));
        },
        updateAllUsersOrganizationMemberships(organizationType, options) {
            return localVarFp.updateAllUsersOrganizationMemberships(organizationType, options).then((request) => request(axios, basePath));
        },
        updateCurrentUserOrganizationMemberships(currentUserMembershipsRequest, options) {
            return localVarFp.updateCurrentUserOrganizationMemberships(currentUserMembershipsRequest, options).then((request) => request(axios, basePath));
        },
        updateUserOrganizationMemberships(organizationId, userMembershipsRequest, options) {
            return localVarFp.updateUserOrganizationMemberships(organizationId, userMembershipsRequest, options).then((request) => request(axios, basePath));
        },
    };
};
export class UserOrganizationMembershipControllerApi extends BaseAPI {
    addUserOrganizationMemberships(organizationId, userMembershipsRequest, options) {
        return UserOrganizationMembershipControllerApiFp(this.configuration).addUserOrganizationMemberships(organizationId, userMembershipsRequest, options).then((request) => request(this.axios, this.basePath));
    }
    deleteUserOrganizationMembership(organizationId, userIdsRequest, options) {
        return UserOrganizationMembershipControllerApiFp(this.configuration).deleteUserOrganizationMembership(organizationId, userIdsRequest, options).then((request) => request(this.axios, this.basePath));
    }
    updateAllUsersOrganizationMemberships(organizationType, options) {
        return UserOrganizationMembershipControllerApiFp(this.configuration).updateAllUsersOrganizationMemberships(organizationType, options).then((request) => request(this.axios, this.basePath));
    }
    updateCurrentUserOrganizationMemberships(currentUserMembershipsRequest, options) {
        return UserOrganizationMembershipControllerApiFp(this.configuration).updateCurrentUserOrganizationMemberships(currentUserMembershipsRequest, options).then((request) => request(this.axios, this.basePath));
    }
    updateUserOrganizationMemberships(organizationId, userMembershipsRequest, options) {
        return UserOrganizationMembershipControllerApiFp(this.configuration).updateUserOrganizationMemberships(organizationId, userMembershipsRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
//# sourceMappingURL=api.js.map